module.exports = __webpack_public_path__ + "img/bmpcimg1.c3b44bd6.png";